/**
 * 毛坯房精装-图片控制
 * @returns
 */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Button,
  Flex,
} from "@chakra-ui/react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
};

const SmrDeleteModal = (props: Props) => {
  const { isOpen, onClose, onDelete } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent background="#161922">
        <ModalHeader color="#27314D" fontSize={"18px"}></ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody p={6}>
          <Box fontSize={"16px"} color="#FFFFFF">
            所选内容将被删除，确定删除？
          </Box>
          <Flex mt="40px" justifyContent={"flex-end"}>
            <Button
              w="76px"
              h="32px"
              mr="15px"
              bg="#1E253F"
              color={"#FFFFFF"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={"38px"}
              _hover={{
                bg: "#CBD1DF",
                color: "#8E94A9",
              }}
              onClick={() => onClose()}
            >
              取消
            </Button>
            <Button
              w="76px"
              h="32px"
              color={"#FFFFFF"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={"38px"}
              background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
              _hover={{
                background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
              }}
              onClick={onDelete}
            >
              确定
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SmrDeleteModal;
